export function header() {
    const headerEl = document.querySelector(".header");
    const darkSections = document.querySelectorAll(".dark");

    if (!headerEl) return;

    function checkHeaderPosition() {
        const headerRect = headerEl.getBoundingClientRect();
        const isInsideDark = Array.from(darkSections).some(section => {
            const rect = section.getBoundingClientRect();
            return (
                headerRect.top >= rect.top &&
                headerRect.bottom <= rect.bottom
            );
        });

        headerEl.classList.toggle("header--dark", isInsideDark);
    }

    function handleScroll() {
        const currentScrollY = window.scrollY;

        // --- Header scroll class ---
        if (currentScrollY > 200) {
            headerEl.classList.add("header--scroll");
        } else if (currentScrollY === 0) {
            headerEl.classList.remove("header--scroll");
        }

        // --- Check of header in dark section zit ---
        checkHeaderPosition();
    }

    window.addEventListener("scroll", handleScroll, { passive: true });
    window.addEventListener("resize", checkHeaderPosition);
    checkHeaderPosition(); // direct checken bij pageload
}
